import * as React from 'react';
const SvgSearchIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#7B867C"
      d="M19.416 19.416a1.874 1.874 0 0 1-2.651 0l-3.309-3.308A8.699 8.699 0 0 1 8.75 17.5a8.75 8.75 0 1 1 8.75-8.75 8.699 8.699 0 0 1-1.392 4.706l3.308 3.309a1.873 1.873 0 0 1 0 2.651ZM8.75 2.5a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Z"
    />
  </svg>
);
export default SvgSearchIcon;
